import { FaDiamond } from "react-icons/fa6";

export const specialities = {
  TaxAndRegulatory: (
    <div>
      <h3>Expertise</h3>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Income Tax
      </p>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Goods and Service Tax
      </p>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Customs
      </p>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        International Tax
      </p>
      <p>
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Profession Tax
      </p>
    </div>
  ),
  AuditAndAssurance: (
    <div>
      <h3>Expertise</h3>

      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Statutory Audits
      </p>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Internal Audits
      </p>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Tax Audits
      </p>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Bank Audits
      </p>
    </div>
  ),
  CorporateLawServices: (
    <div>
      <h3>Expertise</h3>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Direct Taxation – Domestic
      </p>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        International Taxation
      </p>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Transfer Pricing
      </p>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Indirect Taxation – GST, Excise, Customs
      </p>
    </div>
  ),
  AdvisoryServices: (
    <div>
      <h3>Expertise</h3>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Business setup and process development
      </p>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Corporate mergers and acquisitions
      </p>
    </div>
  ),
  AccountingAndBookkeeping: (
    <div>
      <h3>Expertise</h3>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Cloud accounting and financial reporting
      </p>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Reporting dashboard
      </p>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Process and Reporting automation
      </p>
    </div>
  ),
  ComplianceAndRegulatory: (
    <div>
      <h3>Expertise</h3>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Company Formation
      </p>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Statutory Regulatory Compliance
      </p>
      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        ODI and FDI Compliance
      </p>

      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        SEZ Setup and reportings
      </p>

      <p>
        {" "}
        <span className="diamond-icon">
          <FaDiamond />
        </span>
        Employee Benefit Compliance
      </p>
    </div>
  ),
  SpecializedServices: (
    <div>
      <h3>Expertise</h3>
      {[
        "Accurate and well in time valuation services",
        "Tailor made solutions for ERP",
      ].map((service, index) => (
        <p key={index}>
          <span className="diamond-icon">
            <FaDiamond />
          </span>
          {service}
        </p>
      ))}
    </div>
  ),
  VirtualCFOServices: (
    <div>
      <h3>Virtual CFO Services</h3>
      {[
        "Financial Planning & Strategy",
        "Accounting & Compliance",
        "Tax Planning & Compliance",
        "Fundraising & Investor Relations",
      ].map((service, index) => (
        <p key={index}>
          <span className="diamond-icon">
            <FaDiamond />
          </span>
          {service}
        </p>
      ))}
    </div>
  ),
};
